import { Image } from "@kazaar-platform/design-system";
import { type ReactNode } from "react";
import KazaarTemplateImage from "@/assets/img/kazaar-default-screen.webp";
import KazaarLogo from "@/assets/logos/kazaar_logo_white.svg";

interface TemplateKazaarPageProps {
  children?: ReactNode;
  isLogoVisible?: boolean;
}

export const TemplateKazaarPage = ({
  children,
  isLogoVisible = true,
}: TemplateKazaarPageProps) => {
  return (
    <div
      className="flex h-screen w-screen items-center overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${KazaarTemplateImage})` }}
    >
      {children}

      {isLogoVisible && (
        <div className="mt-[20%] flex h-screen w-1/3 items-start justify-center text-center text-5xl text-white">
          <Image src={KazaarLogo} alt="" className="max-w-[50%]" />
        </div>
      )}
    </div>
  );
};
